export const PERSONAL_STATE_WHITELIST =
  CONFIG.envConfig.ipcm.values.qqsStateWhitelist ||
  ENV_INFO.qqsStateWhitelistDefault;
export const COMMERCIAL_STATE_WHITELIST =
  CONFIG.envConfig.ipcm.values.qqsStateWhitelistCommercial ||
  ENV_INFO.qqsStateWhitelistCommercialDefault;

export const COMMERCIAL_INSURANCE_TYPE = "commercial";
export const PERSONAL_INSURANCE_TYPE = "personal";

export const QUOTE_ORIGINATION_SYSTEM = {
  AP: "Agent Portal",
  AP_FP: "Agent Portal - FastPremium"
};

export const dateFormat = "MM/dd/yyyy";

export const formMetaDefaults = {
  areFastPremiumQuestionsComplete: false,
  currentEstimate: NaN,
  propertyDetails: {}
};

export const fastPremiumTooltipCopy = `Save time by setting fast premium coverage
defaults for common coverage options. These defaults will apply to
 quotes you start with Fast Premium.`;
